import FaIcon from '@app/lui3/FaIcon';

import {useRoamingSettings} from '../../../RoamingSettingsContext';
import {
  RecipientBtn,
  RecipientEmail,
  RecipientName,
  RecipientRowContainer,
  RecipientTextBlock,
} from './styles';
import {OutlookRecipient} from './useOutlookEmailRecipients';

interface Props {
  recipient: OutlookRecipient;
  agencyId: number;
}

const OtherRecipient = ({recipient, agencyId}: Props) => {
  const {podUrl} = useRoamingSettings();

  const params = new URLSearchParams({
    show_person_create_modal: 'true',
    person_create_modal_email: recipient.email,
    person_create_modal_name: recipient.name ?? recipient.email,
  });

  const addUrl = `${podUrl}/agencies/${agencyId}/people?${params.toString()}`;

  return (
    <RecipientRowContainer>
      <RecipientTextBlock>
        <RecipientName>{recipient.name ?? recipient.email}</RecipientName>
        <RecipientEmail>{recipient.email}</RecipientEmail>
      </RecipientTextBlock>
      <RecipientBtn
        size="medium"
        after={<FaIcon icon="arrow-up-right" size="sm" />}
        onClick={() => {
          window.open(addUrl, '_blank');
        }}
        color="primary"
        variant="filled"
      >
        Add
      </RecipientBtn>
    </RecipientRowContainer>
  );
};

export default OtherRecipient;
